import { getFirstFocusables } from './getFirstFocusables.js';

export function focusFirst(elem) {
  const el = getFirstFocusables(elem);
  if (el) {
    el.focus();
    return true;
  }
  return false;
}
